// src/components/Switch.tsx — interrupteur à bascule réutilisable (pastille glissante), couleur
// de sélection standard de l'appli (var(--green-dim)) à l'état actif.

export function Switch({ checked, onChange, disabled, title }: {
  checked: boolean; onChange: () => void; disabled?: boolean; title?: string;
}) {
  return (
    <button onClick={onChange} disabled={disabled} type="button" title={title}
      style={{position:"relative",width:36,height:20,borderRadius:999,border:"none",padding:0,flexShrink:0,
        background:checked?"var(--green-dim)":"#ccc",
        cursor:disabled?"not-allowed":"pointer",transition:"background 0.15s"}}>
      <span style={{position:"absolute",top:2,left:checked?18:2,width:16,height:16,
        borderRadius:"50%",background:"#fff",boxShadow:"0 1px 3px rgba(0,0,0,0.3)",
        transition:"left 0.15s"}}/>
    </button>
  );
}
